import { SmallLoaderComponent } from './components/small-loader/small-loader.component';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StringJoinPipe } from './pipes/stringjoin.pipe';
import { UrlRewritePipe } from './pipes/urlrewrite.pipe';
import { LoaderIndicatorComponent } from './components/loading-indicator/loading-indicator.component';
import { HeaderComponent } from './components/header/header.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { IconComponent } from './components/icon/icon.component';
import { ScrollToDirective } from './directives/scroll-to.directive';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { SortByPipe } from './pipes/sort-by.pipe';
import { SortByLengthPipe } from './pipes/sort-by-length.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { YoutubeComponent } from './components/youtube/youtube.component';
import { Html5VideoComponent } from './components/html5video/html5video.component';
import { TeaserComponent } from './components/teaser/teaser.component';
import { InViewportDirective } from './directives/in-view.directive';
import { CountDirective } from './directives/count.directive';
import { ClockComponent } from './components/clock/clock.component';
import { MenuComponent } from './components/menu/menu.component';
import { SafePipe } from './pipes/safe.pipe';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmDeleteDialogComponent } from './dialogs/confirm-delete/confirm-delete-dialog.component';
import { DialogService } from './services/dialog.service';
import { PlatformModule } from '@angular/cdk/platform';

import { LinkyModule } from 'ngx-linky';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { AsArticlePipe } from './pipes/as-article.pipe';
import { AsPostPipe } from './pipes/as-post.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';

const moduleExports = [
  ClockComponent,
  StringJoinPipe,
  UrlRewritePipe,
  StripHtmlPipe,
  TruncatePipe,
  SortByPipe,
  SearchPipe,
  LoaderIndicatorComponent,
  HeaderComponent,
  TopbarComponent,
  IconComponent,
  ScrollToDirective,
  SortByLengthPipe,
  SafePipe,
  FooterComponent,
  YoutubeComponent,
  Html5VideoComponent,
  TeaserComponent,
  InViewportDirective,
  CountDirective,
  MenuComponent,
  TimeAgoPipe,
  SmallLoaderComponent,
  ConfirmDeleteDialogComponent,
  AsArticlePipe,
  AsPostPipe,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatBadgeModule,
    PlatformModule,
    MatSnackBarModule,
    LinkyModule,
    TruncateModule,
  ],
  declarations: [...moduleExports],
  exports: [...moduleExports],
  providers: [DialogService],
})
export class CoreModule {}
